import { render, staticRenderFns } from "./popupquote.vue?vue&type=template&id=96a6bcce&scoped=true"
import script from "./popupquote.vue?vue&type=script&lang=ts"
export * from "./popupquote.vue?vue&type=script&lang=ts"
import style0 from "./popupquote.vue?vue&type=style&index=0&id=96a6bcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a6bcce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
